import { render, staticRenderFns } from "./StockLogDetail.vue?vue&type=template&id=4c2c4d92&scoped=true&lang=pug&"
import script from "./StockLogDetail.vue?vue&type=script&lang=ts&"
export * from "./StockLogDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StockLogDetail.vue?vue&type=style&index=0&id=4c2c4d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c4d92",
  null
  
)

export default component.exports